"use strict";

var httpLib = require("./http-library.js");
var publicConfig = require("../public-config.js");
var ssoHost = publicConfig.external_address;
exports.Profile = {
  create: function createProfile(profileBody, callback) {
    var requestBody = profileBody;
    requestBody.grant_type = 'signup';
    var requestParams = {
      host: ssoHost,
      path: '/v1/profiles',
      method: 'POST'
    };
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, requestBody);
  },
  createSocial: function createProfile(profileBody, callback) {
    var requestBody = profileBody;
    requestBody.grant_type = 'social_signup';
    var requestParams = {
      host: ssoHost,
      path: '/v1/profiles',
      method: 'POST'
    };
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, requestBody);
  },
  read: function readProfile(path, accessToken, callback) {
    var requestParams = {
      host: ssoHost,
      path: path,
      method: 'GET'
    };
    if (accessToken) {
      requestParams.headers = {
        Authorization: 'Bearer ' + accessToken
      };
    }
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  },
  update: function updateProfile(path, accessToken, profileBody, callback) {
    var requestParams = {
      host: ssoHost,
      path: '/v1/profiles/' + path,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, function (response) {
      callback(response);
    }, profileBody);
  }
};